import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { UserDataService } from '../shared/services/auth/userData.service';
import { filter, Subscription } from 'rxjs';
declare var initFlowbite: any;
import { FlowbiteService } from '../shared/services/flowbite.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule    
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'tips-dash-v2';
  private subscriptions: Subscription = new Subscription();
  private readonly activatedRoute = inject(ActivatedRoute);

  constructor(
    private flowbiteService: FlowbiteService,
    private router: Router,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    let isInIframe = false;
    try {
      isInIframe = window.self !== window.top;
    } catch {
      isInIframe = true;
    }

    if (!isInIframe) {
      this.router.navigate(['/not-found']);
      return;
    }

    this.flowbiteService.loadFlowbite((flowbite) => {});
    // Delay the Flowbite initialization to ensure the DOM is ready
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => {
          initFlowbite();
        }, 100);
      });

    // Authorization check
    this.activatedRoute.paramMap.subscribe((params) => {
      const buildingId = params.get('buildingId');
      if (buildingId) {
        this.userDataService.setBuildingId(buildingId);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe(); // Unsubscribe from all subscriptions
  }
}
